import { render, staticRenderFns } from "./CardTestigos.vue?vue&type=template&id=57f91b59&scoped=true"
import script from "./CardTestigos.vue?vue&type=script&lang=js"
export * from "./CardTestigos.vue?vue&type=script&lang=js"
import style0 from "./CardTestigos.vue?vue&type=style&index=0&id=57f91b59&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f91b59",
  null
  
)

export default component.exports